import { ANTD_THEME_TOKEN } from '@zero/shared';

/**
 * 创作者平台专属 Antd 主题 token。
 * 在共享 ANTD_THEME_TOKEN 上做一次"发光润色"：更柔的背景、更亮的金琥珀、
 * 更大的圆角和更紧的字距 — 让整体视觉看起来像一个精工 SaaS 工作台。
 */
export const CREATOR_THEME_TOKEN = {
  ...ANTD_THEME_TOKEN,
  colorPrimary: '#D97706',
  colorPrimaryHover: '#F59E0B',
  colorPrimaryActive: '#B45309',
  colorLink: '#B45309',
  colorBgLayout: '#FBFAF7',
  colorBgContainer: '#FFFFFF',
  colorBgElevated: '#FFFFFF',
  colorBorder: '#E7E2D6',
  colorBorderSecondary: '#F0EBDE',
  borderRadius: 10,
  borderRadiusSM: 6,
  borderRadiusLG: 14,
  fontSize: 14,
  fontSizeHeading1: 30,
  fontSizeHeading2: 24,
  fontSizeHeading3: 20,
  fontSizeHeading4: 16,
  lineHeight: 1.6,
  controlHeight: 36,
  boxShadow:
    '0 1px 2px rgba(17, 12, 3, 0.04), 0 1px 3px rgba(17, 12, 3, 0.06)',
  boxShadowSecondary:
    '0 4px 12px rgba(180, 83, 9, 0.08), 0 2px 4px rgba(17, 12, 3, 0.04)',
} as const;

export const CREATOR_COLORS = {
  amber50: '#FEF9EC',
  amber100: '#FEF3C7',
  amber200: '#FDE68A',
  amber500: '#F59E0B',
  amber600: '#D97706',
  amber700: '#B45309',
  amber800: '#92400E',
  green600: '#15803D',
  green50: '#ECFDF5',
  slate50: '#F8FAFC',
  slate100: '#F1F5F9',
  slate200: '#E2E8F0',
  slate400: '#94A3B8',
  slate600: '#475569',
  slate800: '#1E293B',
  bg: '#FBFAF7',
  bgSoft: '#F6F3EC',
  borderSoft: '#EEE7D4',
} as const;
